
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "class": "icon",
    "width": "200px",
    "height": "200.00px",
    "viewBox": "0 0 1024 1024",
    "version": "1.1",
    "xmlns": "http://www.w3.org/2000/svg"
  },
  "children": [
    {
      "tag": "path",
      "attrsMap": {
        "d": "M862.540252 100.347886H161.560096A154.98731 154.98731 0 0 0 7.174874 255.887109v514.383262a154.937136 154.937136 0 0 0 154.385222 155.188005h700.980156a154.98731 154.98731 0 0 0 154.435396-155.188005V255.887109a154.98731 154.98731 0 0 0-154.435396-155.539223zM161.560096 181.479151h700.980156A74.157088 74.157088 0 0 1 936.44647 255.887109v371.287177l-91.818316-176.060366a112.23911 112.23911 0 0 0-180.626194-25.990102l-161.810966 168.684796a16.808271 16.808271 0 0 1-23.581753 0.551913l-90.313097-85.797442a108.526238 108.526238 0 0 0-141.942085-7.726787l-158.650007 122.625116V255.887109A74.157088 74.157088 0 0 1 161.560096 181.479151z m700.980156 663.048655H161.560096a74.157088 74.157088 0 0 1-73.856044-74.257435v-44.704983l207.770298-160.556617a28.699495 28.699495 0 0 1 37.530109 1.956783l90.313097 85.797443a97.136753 97.136753 0 0 0 136.874516-3.160959l161.86114-168.684796a31.910628 31.910628 0 0 1 51.327943 7.425744l159.302269 305.458964a74.05674 74.05674 0 0 1-70.143172 50.725856z",
        "fill": "#ffffff"
      }
    },
    {
      "tag": "path",
      "attrsMap": {
        "d": "M163.667402 318.353667a74.407957 74.05674 90 1 0 148.113479 0 74.407957 74.05674 90 1 0-148.113479 0Z",
        "fill": "#ffffff"
      }
    }
  ]
})
    }
  